import { useState } from "react";
import { ProductResponse } from "../../../types/product.type";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import ProductDeleteDialog from "./ProductDeleteDialog";

interface DeleteProductButtonProps {
  /** The stored record the drawer loaded; null while it is still loading. */
  product: ProductResponse | null;
  disabled: boolean;
  onDeleted: () => void;
  /** The product was switched off instead of deleted. */
  onDeactivated: () => void;
}

/** The drawer footer's delete, opening the same dialog as the list row. */
export default function DeleteProductButton({
  product,
  disabled,
  onDeleted,
  onDeactivated,
}: DeleteProductButtonProps) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleAskDelete = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const deleteTarget = dialogOpen ? product : null;

  return (
    <>
      <Button
        color="error"
        variant="outlined"
        startIcon={<DeleteIcon />}
        disabled={disabled || !product}
        onClick={handleAskDelete}
      >
        ลบ
      </Button>

      <ProductDeleteDialog
        product={deleteTarget}
        onClose={handleCloseDialog}
        onDeleted={onDeleted}
        onDeactivated={onDeactivated}
      />
    </>
  );
}
